import React, { Component } from 'react';
import './Toasts.css';
import Label from '../label/Label';
import mainAPI from "../../api/MainAPI";

export default class Toasts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
			classes: '',
			text: ''
		};
		window.showToast = this.show;
	}
	show = (text, time = 2000, type='info') => {
		this.setState({ text, open: true, classes: '' }, () => {
			this.setState({ classes: 'open' });
		});
		setTimeout(() => {
			this.setState({ open: false, classes: '' });
		}, time);
		this.reportToastToAPI(text, type)
	};
	reportToastToAPI = async (message, type) => {
		try {
			await mainAPI.toasts.create({message, type});
		} catch(e) {
			console.error(e);
		}
	};
	render() {
		return (
			<div className={'g-toasts ' + this.state.classes}>
				<Label  medium-plus black>
					{this.state.text}
				</Label>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/toasts/Toasts.jsx